function Politica() {
  return (
    <>
      <h3 style={{ fontSize: '1.25em', wordWrap: "break-word" }}>Políticas de protección de datos</h3>
      <p style={{wordWrap: "break-word" }}>
        El responsable del tratamiento es la Oficina Española de Patentes y
        Marcas. Puede contactar con el responsable en{" "}
        <a href="mailto:protecciondedatos@oepm.es">protecciondedatos@oepm.es</a>
        . La legitimidad del tratamiento de sus datos personales se basa en el
        consentimiento. En ausencia de su consentimiento no podremos ofrecerle
        el servicio de reutilización. Los datos se tratarán exclusivamente para
        controlar y monitorizar el acceso a los ficheros de datos reutilizables.
        Puede ejercer sus derechos en{" "}
        <a href="mailto:protecciondedatos@oepm.es">protecciondedatos@oepm.es</a>{" "}
        o en la Agencia Española de Protección de Datos.{" "}
        <a href="https://www.aepd.es">www.aepd.es</a>.
      </p>
    </>
  );
}

export default Politica;
